<template>
    <!-- 虚拟奖品用户信息录入弹窗 -->
    <van-dialog v-model="isVisibility" :show-confirm-button="false" class-name="vertical-center-modal" :styles="{top: '100px'}">
        <div class="diyModal">
            <!--中奖内容文本-->
            <div v-if="!isReceived" class="awardContent">
                <div class="virtualOnline">请填写您的兑换信息</div>
                <div class="customerInfo" style="padding: 0 15px;">
                  <!-- 历史数据走这里 -->
                  <div v-if="userInfoList && userInfoList.length === 0">
                    <!-- 顾客姓名 -->
                    <van-cell-group class="group1">
                        <van-field v-model="modelFormCustom.userName" size='large' label-width="65px" label="姓名" @focus="isUserName=true" @blur="isUserName=false" :placeholder="!isUserName?'请输入姓名':''" clearable/>
                    </van-cell-group>
                    <!-- 顾客电话 -->
                    <van-cell-group>
                        <van-field v-model="modelFormCustom.userPhone" size='large' label-width="65px" label="电话" @focus="isUserPhone=true" @blur="isUserPhone=false" :placeholder="!isUserPhone?'请输入电话':''" clearable/>
                    </van-cell-group>
                  </div>
                  <div v-else>
                    <van-cell-group v-for="(item,index) in userInfoList"
                        :key="index"
                        class="group1">
                        <van-field v-model="item.fieldVal"
                            size="large"
                            label-width="65px"
                            :label="item.fieldName"
                            :placeholder="item.fieldTips"
                            maxlength="200"
                            clearable />
                    </van-cell-group>
                    </div>
                </div>
                <div class="diyModalButtonText">
                  <van-button round type="info" @click="modalOk">提交</van-button>
                </div> 
            </div>
            <!-- 领取之后再次打开，展示获得卡密 -->
            <div v-if="isReceived" class="awardContent">
              <div class="virtualOnline">恭喜您获得卡密</div>
              <div class="pleaseCopy">请截图或复制使用</div>
              <div class="snCode">{{ awardObj.activationCode }}</div>
              <div class="diyModalButtonText">
                <van-button v-clipboard:copy="awardObj.activationCode" v-clipboard:success="onCopy" v-clipboard:error="onError"
                  plain round type="info" class="copyButtonText">复制卡密</van-button>
              </div>
            </div>
            <div class="diyClose" @click="modalCancel(true)"><van-icon name="close" /></div>
        </div>
    </van-dialog>
</template>

<script>
import { config as configEnv} from '../../../../../commons/config.js'
import { Dialog, Cell, CellGroup, Icon, Field, Toast, Button } from "vant";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Button.name]: Button
  },
  props: {
    awardObj: Object,//活动、权益品、卡密信息
    // 获取抽奖次数方式
    userBase: Object,//用户信息
    goodsIndex: Number,//领取的权益品的index-为了抛出入参时在父组件进行领取状态更改
    isReceived: Boolean,//是否已领取过卡密  true-展示卡密 false-填写信息
    userInfoList: Array
  },
  data() {
    return {
      isVisibility: false,
      modelFormCustom: {
        userName: "",
        userPhone: ""
      },
      isUserName: false,
      isUserPhone: false,
      errorTime:true,
      errorMessage:"",
      env: configEnv.env !== 'pro' ? 'trial': 'release' // 判断当前环境变量，env-version默认正式版release，为方便测试增加体验版trial跳转
    };
  },
  created() {},
  mounted() {},
  methods: {
    onCopy() {
      console.log("this.awardObj",this.awardObj)
      Toast('复制成功！');
      setTimeout(() => {
        this.$emit('nextStep') // 跳转配置用到，不用父组件则不加
        this.$emit('getExchangeGoodsToUrl',this.awardObj.jumpUrl)
      }, 1000);
    },
    onError() {
      Toast('复制失败！');
      setTimeout(() => {
        this.$emit('nextStep') // 跳转配置用到，不用父组件则不加
      }, 1000);
    },
    modalOk() {
      const self = this;
      // 历史数据走这里
      if (this.userInfoList && this.userInfoList.length === 0) {
        const obj = Object.assign({}, self.modelFormCustom);
        if (!obj.userName) {
          Toast("请输入姓名");
          return false;
        } else if (!obj.userPhone) {
          self.$utils.tips.message("warning", "请输入电话！");
          Toast("请输入电话");
          return false;
        } else if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
          Toast("请输入正确的电话号码");
          return false;
        }
        const privacyKeys = {
          userName: "$PrivacyPlain$",
          userPhone: "$PrivacyPlain$"
        };
        //隐私信息保存
        const privacyKeyLsit = [
          {
            userName: "userName",
            typeText: "NAME",
            labelText: "mktMagicShareCpsUserName"
          },
          {
            userPhone: "userPhone",
            typeText: "MOBILE_PHONE_NO",
            labelText: "mktStudentRewardRecodeUserPhone"
          }
        ];
        self.$utils.privacySave(privacyKeys, privacyKeyLsit, obj);
        self.$emit("handleVirtualOnline",self.awardObj,self.goodsIndex,obj.userName,obj.userPhone)
        // 配置展示内容走这里
      } else {
        const userInfoList = JSON.parse(JSON.stringify(this.userInfoList));
        const obj = this.userInfoList.find(item => !item.fieldVal);
        if(obj){
          Toast(obj.fieldTips);
          return
        }
        userInfoList.forEach((item) => {
          const privacyObjs = {
            bizObjectId: 'mktExchangeGoodsOthers', //字段名,写死
            channelId: '872cc0ff763db3950176427d145b0332', //固定
            userId: '', //非必填   取登录人
            type: 'OTHERS', //隐私类型
            bizObjectType: 'OTHER',
            opt: '$PrivacySensitized$',
            plainText: item.fieldVal, //明文
          };
          item.fieldVal = privacyObjs;
        });
        const params = {
          userInfoList: userInfoList
        };
        self.$emit("handleVirtualOnline",self.awardObj,self.goodsIndex,params)
      }
    },
    modalCancel() {
      setTimeout(()=>{ 
        this.isVisibility = false;
        this.$emit('closeEnd')
      },300)
    },
    async openModel() {
      this.isVisibility = true;
      if(this.userInfoList && this.userInfoList.length === 0){
        for (let k in this.modelFormCustom) {
          this.modelFormCustom[k] = '';
        }
      }else{
        this.userInfoList.forEach((item) => {
          item.fieldVal = null
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.van-button {
  width: 200px;
}
.van-dialog {
  width: 100%;
  overflow: initial;
  background-color: transparent;
  /deep/ .van-dialog__content {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 111vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .diyModal {
      width: 320px;
      height: auto;
      margin: auto;
      min-height: 245px;
      position: relative;
      z-index: 10;
      .awardContent {
        width: 95%;
        min-height: 120px;
        margin: 0 2.5%;
        background-image: linear-gradient(180deg, #ffffff 0%, #f8fbff 25% #f1f6ff 50%, #eaf1ff 75%, #e2ecff 100%);
        text-align: center;
        border-radius: 20px;
        margin-top: 20px;
        // background-image: linear-gradient( #fff, skyblue 250%);
        .virtualOnline {
          font-size: 20px;
          font-weight: 900;
          padding: 26px 0 0;
          color: #000;
        }
        .pleaseCopy {
          font-size: 16px;
          color: #999999;
          text-align: center;
          font-weight: 400;
          margin-top: 5px;
        }
        .snCode {
          font-size: 24px;
          color: #000000;
          text-align: center;
          font-weight: 500;
          margin: 52px 0 70px;
          word-break: break-all;
          padding: 0 30px;
        }
        .customerInfo {
          margin-top: 20px;
        }
        .van-cell-group {
          background-color: rgba(0, 0, 0, 0) !important;
          border-bottom: 1px solid #e5e5e5;
          .van-cell {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          .van-cell--large .van-cell__title {
            font-size: 14px;
          }
        }
        .diyModalButtonText {
          margin-top: 40px;
          padding-bottom: 20px;
          .copyButtonText{
            width: 77%;
            font-size: 16px;
            background: rgba(0,0,0,0);
          }
        }
      }
      .diyClose {
        width: 30px;
        height: 30px;
        font-size: 36px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -50px;
        z-index: 10000;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/virtual-online.vue